import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyAaCPgDGhQx8ksKA9TDWMk40WXlWQoMIos",
  authDomain: "inmobiliariazapiola.firebaseapp.com",
  projectId: "inmobiliariazapiola",
  storageBucket: "inmobiliariazapiola.firebasestorage.app",
  messagingSenderId: "297368870815",
  appId: "1:297368870815:web:8e28ddb4572549286fa7aa",
  measurementId: "G-1EL9X996JJ",
};

const app = initializeApp(firebaseConfig);

// Inicializa Firestore y Storage pasando la instancia de app
export const db = getFirestore(app);
export const storage = getStorage(app);
export const auth = getAuth(app);

export default app;
